export function isBlobStorageUrl(url: string): boolean {
  if (!url) return false;

  // Only consider absolute URLs (with scheme) or protocol-relative URLs (`//host/...`).
  const isAbsolute = /^[a-zA-Z][a-zA-Z\d+\-.]*:\/\//.test(url) || url.startsWith('//');
  if (!isAbsolute) return false;

  try {
    // `new URL()` no acepta un protocol-relative URL (`//host/...`) sin un `base` — se le
    // agrega un scheme dummy solo para poder parsearlo, el hostname no cambia.
    const parsed = new URL(url.startsWith('//') ? `https:${url}` : url);
    const hostname = parsed.hostname.toLowerCase();
    return (
      hostname === 'blob.core.windows.net' ||
      hostname.endsWith('.blob.core.windows.net')
    );
  } catch {
    // Fallback: try to extract hostname from absolute o protocol-relative URLs via regex
    const match = /^(?:[a-zA-Z]+:)?\/\/([^/:?#]+)(?::\d+)?/.exec(url);
    if (match?.[1]) {
      const hostname = match[1].toLowerCase();
      return (
        hostname === 'blob.core.windows.net' ||
        hostname.endsWith('.blob.core.windows.net')
      );
    }

    return false;
  }
}
